import T from "utils/T";

const GLOCOSE_TYPES = {
  'H': T('고혈당'),
  'L': T('저혈당'),
  'V': T('변동혈당'),
  'N': T('정상'),
};

export default GLOCOSE_TYPES;